import Image from "next/image";
import {
  Container,
} from "./styled";
import { useWindowDimensions } from "../../../hooks";

const Banner = () => {
  const { isMobile } = useWindowDimensions();
  const imgPath = !isMobile
    ? "/images/our-story/roger-patti.jpg"
    : "/images/our-story/roger-patti.jpg";

  return (
    <Container>
      <Image
        alt="ourstory banner"
        src={imgPath}
        layout="fill"
        objectFit="cover"
        loading="lazy"
        quality={70}
      />
    </Container>
  );
};

export default Banner;
